import { getString } from "../common/common";

export const ONWARD_TRIP = "ONWARD_TRIP";
export const RETURN_TRIP = "RETURN_TRIP";
export const PREV_DAY_TRIPS = "PREV_DAY_TRIPS";
export const NEXT_DAY_TRIPS = "NEXT_DAY_TRIPS";
export const START_TRIP = "START_TRIP";
export const CONNECT_TRIP = "CONNECT_TRIP";

export const SORT_BY = "SORT_BY";
export const DEPARTURE_TIME = "DEPARTURE_TIME";
export const JOURNEY_DURATION = "JOURNEY_DURATION";
export const ARRIVAL_TIME = "ARRIVAL_TIME";
export const SEAT_FARE = "SEAT_FARE";

export const STARTS_AT = "STARTS_AT";
export const DURATION = "DURATION";
export const REACHES_ON = "REACHES_ON";
export const VIA = "VIA";
export const AVAILABLE = "AVAILABLE";

export const BOARDING_POINTS = "BOARDING_POINTS";
export const CANCELLATION_POLICY = "CANCELLATION_POLICY";
export const DROPPING_POINTS = "DROPPING_POINTS";
export const VIA_CITIES = "VIA_CITIES";
export const AMENITIES = "AMENITIES";
export const BUS_PICTURES = "BUS_PICTURES";

export const TP_STRTS_FRM = "TP_STRTS_FRM";
export const TM_BFR_TP_STRT = "TM_BFR_TP_STRT";
export const CANC_CHGS = "CANC_CHGS";

export const EXT_OFF_RND_TP = "EXT_OFF_RND_TP";
export const RND_TP_DISC = "RND_TP_DISC";
export const NO_DATA_FND = "NO_DATA_FND";
export const NON_RFNDBLE = "NON_RFNDBLE";
export const SAFE_BUS = "SAFE_BUS";
export const NON_RSRVBLE = "NON_RSRVBLE";
export const SPL_B = "SPL_B";

export const SOLD_OUT = "SOLD_OUT";
export const CLOSE_CHART = "CLOSE_CHART";
export const SELECT_BERTH = "SELECT_BERTH";
export const SELECT_SEATS = "SELECT_SEATS";
export const TRACK_BUS = "TRACK_BUS";

export const HRS = "HRS";
export const WITHIN = "WITHIN";
export const BEFORE = "BEFORE";

export const NO_RESLTS_FND = "NO_RESLTS_FND";
export const REMOVE_FILTER = "REMOVE_FILTER";

export const BUS_TYPE = "BUS_TYPE";
export const DEPOT_NAME = "DEPOT_NAME";
export const SRD = "SRD";

export const translations = {
  en: {
    [ONWARD_TRIP]: "Onward Trip",
    [RETURN_TRIP]: "Return Trip",
    [PREV_DAY_TRIPS]: "Previous Day Trips",
    [NEXT_DAY_TRIPS]: "Next Day Trips",
    [START_TRIP]: "Start Trip",
    [CONNECT_TRIP]: "Connect Trip",

    [SORT_BY]: "Sort By",
    [DEPARTURE_TIME]: "Departure Time",
    [JOURNEY_DURATION]: "Journey Duration",
    [ARRIVAL_TIME]: "Arrival Time",
    [SEAT_FARE]: "Seat Fare",

    [STARTS_AT]: "Starts at",
    [DURATION]: "Duration",
    [REACHES_ON]: "Reaches on",
    [VIA]: "Via",
    [AVAILABLE]: "Available",

    [BOARDING_POINTS]: "Boarding Points",
    [CANCELLATION_POLICY]: "Cancellation Policy",
    [DROPPING_POINTS]: "Dropping Points",
    [VIA_CITIES]: "Via Cities",
    [AMENITIES]: "Amenities",
    [BUS_PICTURES]: "Bus Pictures",

    [TP_STRTS_FRM]: "Trip Starts from:",
    [TM_BFR_TP_STRT]: "Time before Trip Start:",
    [CANC_CHGS]: "Cancellation charges",

    [SPL_B]: "Special Bus",
    [EXT_OFF_RND_TP]: "extra off on round trip",
    [RND_TP_DISC]: "Round trip discount",
    [NO_DATA_FND]: "No data found",
    [NON_RFNDBLE]: "Non Refundable",
    [SAFE_BUS]: "SAFE BUS",
    [NON_RSRVBLE]: "Non Reservable",

    [CLOSE_CHART]: "Close chart",
    [SELECT_BERTH]: "Select Berth",
    [SELECT_SEATS]: "Select Seats",
    [SOLD_OUT]: "Sold Out",

    [TRACK_BUS]: "Track Bus",
    [HRS]: "HRS",
    [BEFORE]: "Before",
    [WITHIN]: "Within",

    [NO_RESLTS_FND]: "Sorry! There were no results found. Please modify your search.",
    [REMOVE_FILTER]: "Remove Filter",

    [BUS_TYPE]: "Bus Type:",
    [DEPOT_NAME]: "Depot Name:",
    [SRD]: "Service Route Details - ",
  },
  kn: {
    [ONWARD_TRIP]: "ಮುಂದಿನ ಪ್ರಯಾಣ",
    [RETURN_TRIP]: "ರಿಟರ್ನ್ ಟ್ರಿಪ್",
    [PREV_DAY_TRIPS]: "ಹಿಂದಿನ ದಿನದ ಟ್ರಿಪ್ ಗಳು",
    [NEXT_DAY_TRIPS]: "ಮರುದಿನ ಟ್ರಿಪ್ ಗಳು",
    [START_TRIP]: "ಟ್ರಿಪ್ ಪ್ರಾರಂಭಿಸಿ",
    [CONNECT_TRIP]: "ಟ್ರಿಪ್ ಅನ್ನು ಸಂಪರ್ಕಿಸಿ",

    [SORT_BY]: "ವಿಂಗಡಿಸು",
    [DEPARTURE_TIME]: "ನಿರ್ಗಮನ ಸಮಯ",
    [JOURNEY_DURATION]: "ಪ್ರಯಾಣದ ಅವಧಿ",
    [ARRIVAL_TIME]: "ಆಗಮನ ಸಮಯ",
    [SEAT_FARE]: "ಸೀಟ್ ದರ",

    [STARTS_AT]: "ನಲ್ಲಿ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ",
    [DURATION]: "ಅವಧಿ",
    [REACHES_ON]: "ಇಂದು ತಲುಪುತ್ತದೆ",
    [VIA]: "ಮೂಲಕ",
    [AVAILABLE]: "ಲಭ್ಯತೆ",

    [BOARDING_POINTS]: "ಹತ್ತುವ ಸ್ಥಳಗಳು",
    [CANCELLATION_POLICY]: "ರದ್ದತಿ ನೀತಿ",
    [DROPPING_POINTS]: "ಇಳಿಯುವ ಸ್ಥಳಗಳು",
    [VIA_CITIES]: "ನಗರಗಳ ಮೂಲಕ",
    [AMENITIES]: "ಸೌಕರ್ಯಗಳು",
    [BUS_PICTURES]: "ಬಸ್ ಚಿತ್ರಗಳು",

    [TP_STRTS_FRM]: "ಟ್ರಿಪ್ ಇಂದಿನಿಂದ ಪ್ರಾರಂಭವಾಗುತ್ತದೆ: ",
    [TM_BFR_TP_STRT]: "ಟ್ರಿಪ್ ಪ್ರಾರಂಭವಾಗುವ ಮೊದಲು ಸಮಯ:",
    [CANC_CHGS]: "ರದ್ದತಿ ಶುಲ್ಕಗಳು",

    [SPL_B]: "ವಿಶೇಷ ಬಸ್",
    [EXT_OFF_RND_TP]: "ರೌಂಡ್ ಟ್ರಿಪ್ ಮೇಲೆ ಹೆಚ್ಚು ರಿಯಾಯಿತಿ",
    [RND_TP_DISC]: "ರೌಂಡ್ ಟ್ರಿಪ್ ರಿಯಾಯಿತಿ",
    [NO_DATA_FND]: "ಯಾವುದೇ ಡೇಟಾ ಕಂಡುಬಂದಿಲ್ಲ",
    [NON_RFNDBLE]: "ರೀಫಾನ್ಡ್ ಮಾಡಲಾಗುವುದಿಲ್ಲ",
    [SAFE_BUS]: "ಸುರಕ್ಷಿತ ಬಸ್",
    [NON_RSRVBLE]: "ರಿಸರ್ವ್ ಮಾಡಲಾಗುವುದಿಲ್ಲ",

    [CLOSE_CHART]: "ಚಾರ್ಟ್ ಅನ್ನು ಮುಚ್ಚಿ",
    [SELECT_BERTH]: "ಬರ್ತ್ ಆಯ್ಕೆಮಾಡಿ",
    [SELECT_SEATS]: "ಆಸನಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    [SOLD_OUT]: "ಮಾರಾಟವಾಗಿದೆ",

    [TRACK_BUS]: "ಬಸ್ ಟ್ರ್ಯಾಕ್  ಮಾಡಿ ",
    [HRS]: "HRS",
    [BEFORE]: "ಮೊದಲು",
    [WITHIN]: "ಒಳಗೆ",

    [NO_RESLTS_FND]: "ಕ್ಷಮಿಸಿ! ಯಾವುದೇ ಫಲಿತಾಂಶಗಳು ಕಂಡುಬಂದಿಲ್ಲ. ದಯವಿಟ್ಟು ನಿಮ್ಮ ಹುಡುಕಾಟವನ್ನು ಮಾರ್ಪಡಿಸಿ..",
    [REMOVE_FILTER]: "ಫಿಲ್ಟರ್ ತೆಗೆದುಹಾಕಿ",

    [BUS_TYPE]: "ಬಸ್ ವರ್ಗ: ",
    [DEPOT_NAME]: "ಡಿಪೋ ಹೆಸರು:",
    [SRD]: "ಸೇವೆಯಲ್ಲಿರುವ ಮಾರ್ಗದ ವಿವರಗಳು - ",
  },
};

export const t = (key = "") => {
  return getString(key, translations)
}